import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import defaultStyles from "./Merchandising.module.scss";
import { useMerchandising } from "./useMerchandising";

type MerchandisingProps = {
  className?: string;
  state?: string;
  postalCode?: string;
};

export const Merchandising = ({
  className,
  state,
  postalCode,
}: MerchandisingProps) => {
  const [block, cn] = useModuleBEM(defaultStyles, "Merchandising");
  const offers = useMerchandising(state, postalCode);

  const hasEvenOffers = offers.length % 2 === 0;
  return (
    <div className={clsx(block, className)}>
      {offers.map((offer, key) => (
        <a
          key={key}
          href={offer.link}
          target="__blank"
          rel="noopener"
          referrerpolicy="no-referrer-when-downgrade"
          className={cn("offer", {
            fullWidth: !hasEvenOffers && key === offers.length - 1,
          })}
        >
          <img src={offer.image} alt="" className={cn("image")} />
          <p
            className={cn("description")}
            dangerouslySetInnerHTML={{ __html: offer.description }}
          ></p>
        </a>
      ))}
    </div>
  );
};
